"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _core = require("@material-ui/core");
var _classnames = _interopRequireDefault(require("classnames"));
var _react = _interopRequireWildcard(require("react"));
var _reactIntl = require("react-intl");
var _Translations = require("react-platform-components/dist/Translations");
var _Stripe = _interopRequireDefault(require("react-platform-purchase/dist/Purchase/Stripe"));
var _StripeCard = _interopRequireDefault(require("react-platform-purchase/dist/Purchase/StripeCard"));
var _reactRedux = require("react-redux");
var _reactRouterDom = require("react-router-dom");
var _reactStripeElements = require("react-stripe-elements");
var _config = require("../config");
var _lodash = _interopRequireDefault(require("lodash"));
var _PromoCode = _interopRequireDefault(require("./components/PromoCode"));
var _Kitty = _interopRequireDefault(require("./components/Kitty"));
var _helpers = require("react-platform-components/dist/helpers");
var _formValidators = require("react-platform-components/dist/form-validators");
var _Quantity = _interopRequireDefault(require("./components/Quantity"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var Colissimo = null;
var COLISSIMO_CHOICE_OF_OPTION_UUID = null;
var ShippingFields = null;
var SHIPPING_FREE_OPTION = null;
var ReservationPresentation;
var RESERVATION_OPTION_UUID;
try {
  Colissimo = require('react-platform-colissimo/dist/Colissimo/ColissimoField').default;
  COLISSIMO_CHOICE_OF_OPTION_UUID = require('react-platform-colissimo/dist/config').COLISSIMO_CHOICE_OF_OPTION_UUID;
} catch (error) {}
try {
  ShippingFields = require('react-platform-shipping/dist/components/ShoppingCartShipping').default;
  SHIPPING_FREE_OPTION = require('react-platform-shipping/dist/config/index').SHIPPING_FREE_OPTION;
} catch (error) {
  //console.log(error)
}
try {
  ReservationPresentation = require('react-platform-reservation/dist/Presentation/ReservationPresentation').default;
  RESERVATION_OPTION_UUID = require('react-platform-reservation/dist/configs/index').RESERVATION_OPTION_UUID;
} catch (error) {}
var useStyles = (0, _core.makeStyles)(function (theme) {
  return {
    cardShadow: {
      boxShadow: '4px 3px 20px #c7c7c7'
    },
    title: {
      marginLeft: '2rem',
      marginTop: '2rem',
      borderLeftStyle: 'solid',
      borderColor: '#37abd9'
    },
    titleText: {
      marginLeft: '1rem',
      fontSize: '1rem'
    },
    itemImage: {
      height: '40px',
      width: '40px',
      marginRight: '.5rem',
      borderRadius: '5px'
    },
    tooltipImage: {
      height: '180px',
      width: '180px',
      marginTop: '5px',
      borderRadius: '5px',
      objectFit: 'contain'
    }
  };
});
function ShoppingCartList(props) {
  var _React$createElement;
  // Define the states and their handlers
  var _useState = (0, _react.useState)(null),
    _useState2 = _slicedToArray(_useState, 2),
    promoCode = _useState2[0],
    setPromoCode = _useState2[1];
  var _useState3 = (0, _react.useState)(0),
    _useState4 = _slicedToArray(_useState3, 2),
    kittyAmount = _useState4[0],
    setKittyAmount = _useState4[1];
  var _useState5 = (0, _react.useState)(false),
    _useState6 = _slicedToArray(_useState5, 2),
    isConditionsChecked = _useState6[0],
    handleConditionsChecked = _useState6[1];
  var _useState7 = (0, _react.useState)(ShippingFields ? false : true),
    _useState8 = _slicedToArray(_useState7, 2),
    isShippingChecked = _useState8[0],
    setIsShippingChecked = _useState8[1];
  var _useState9 = (0, _react.useState)([]),
    _useState10 = _slicedToArray(_useState9, 2),
    shippingAddresses = _useState10[0],
    setShippingAddresses = _useState10[1];
  var _useState11 = (0, _react.useState)(false),
    _useState12 = _slicedToArray(_useState11, 2),
    showPromoCodeField = _useState12[0],
    handlePromoCodeField = _useState12[1];
  var _useState13 = (0, _react.useState)(false),
    _useState14 = _slicedToArray(_useState13, 2),
    addedPromoCode = _useState14[0],
    handleAddedPromoCode = _useState14[1];
  var stripeFormRef = /*#__PURE__*/_react.default.createRef();
  var stripeCardFormRef = /*#__PURE__*/_react.default.createRef();
  var _useState15 = (0, _react.useState)(false),
    _useState16 = _slicedToArray(_useState15, 2),
    shippongSelectionInProgress = _useState16[0],
    setShippongSelectionInProgress = _useState16[1];
  var user = (0, _reactRedux.useSelector)(function (state) {
    var _state$auth;
    return state === null || state === void 0 ? void 0 : (_state$auth = state.auth) === null || _state$auth === void 0 ? void 0 : _state$auth.user;
  });
  (0, _react.useEffect)(function () {
    if (props.user.id && _lodash.default.isEmpty(props.user.mpay_extension) && _config.PAYMENT_METHOD === _config.PAYMENT_METHODS.MANGOPAY) {
      props.dispatch({
        type: 'REDIRECT',
        to: '/mangopay-info',
        history: props.history
      });
    }
    return function () {
      props.dispatch({
        type: 'RESET_CART_TO_DEFAULT'
      });
    };
  }, []);
  // Define style classes
  var classes = useStyles();
  var intl = props.intl,
    openConfirmDialog = props.openConfirmDialog,
    dispatch = props.dispatch,
    history = props.history,
    inProgress = props.inProgress;
  var _useSelector = (0, _reactRedux.useSelector)(function (_ref) {
      var shoppingCartReducer = _ref.shoppingCartReducer;
      return {
        fetchCartInProgress: shoppingCartReducer.fetchCartInProgress,
        cart: shoppingCartReducer.cart
      };
    }),
    fetchCartInProgress = _useSelector.fetchCartInProgress,
    cart = _useSelector.cart;
  (0, _react.useEffect)(function () {
    if (ShippingFields) {
      var _cart$cart_items;
      var tempShippingAddresses = [];
      // Create and array of the addresses that need to be selected for each cart item
      cart === null || cart === void 0 ? void 0 : (_cart$cart_items = cart.cart_items) === null || _cart$cart_items === void 0 ? void 0 : _cart$cart_items.forEach(function (item) {
        var _item$salable_item, _item$salable_item$pr, _item$options_linked_, _selectedShipping$ext;
        var itemShippingOption = (_item$salable_item = item.salable_item) === null || _item$salable_item === void 0 ? void 0 : (_item$salable_item$pr = _item$salable_item.product_options) === null || _item$salable_item$pr === void 0 ? void 0 : _item$salable_item$pr.map(function (item) {
          return item.option.uuid === _config.SHIPPING_OPTION_UUID ? item.choice : [];
        });
        var selectedShipping = (_item$options_linked_ = item.options_linked_to_cart_item) === null || _item$options_linked_ === void 0 ? void 0 : _item$options_linked_.find(function (opt) {
          return opt.option_uuid === _config.SHIPPING_OPTION_UUID;
        });
        var selectedShippingChoiceUUID = selectedShipping === null || selectedShipping === void 0 ? void 0 : (_selectedShipping$ext = selectedShipping.extra_data) === null || _selectedShipping$ext === void 0 ? void 0 : _selectedShipping$ext.choices[0].choice_uuid;
        if ((itemShippingOption === null || itemShippingOption === void 0 ? void 0 : itemShippingOption.length) > 0) {
          // We added this check because when we select an address we commit change (PATCH) to backend and because of that
          // we query also the cart to update it values (total price ....)
          // also because of the query of the cart if we select another shipping method for another cart item before the query
          // finish all the changes that we did will disappear.
          // to handle this problem we check if an address (method of shipping) already exist and save there old value.
          var addressAlreadySelected = shippingAddresses.find(function (address) {
            return address.item.id === item.id;
          });
          if (!addressAlreadySelected) {
            tempShippingAddresses.push({
              item: item,
              choice_uuid: selectedShippingChoiceUUID,
              address: null,
              changed: false
            });
          } else {
            // We needed to update the shipping address state and take the item new value 
            // because the old value of the item has outdated info (the id of the item is changed)
            tempShippingAddresses.push(_objectSpread(_objectSpread({}, addressAlreadySelected), {}, {
              item: item,
              address: null,
              changed: false
            }));
          }
        }
      });
      setShippingAddresses(tempShippingAddresses);
      setShippongSelectionInProgress(false);
    }
  }, [cart]);

  // Handle stripe payment
  var handlePayment = function handlePayment(response) {
    if (!response) {
      // if there is no response show error snackbar
      dispatch({
        type: 'HANDLE_ERROR',
        error: /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
          id: "Something went wrong!",
          defaultMessage: "Something went wrong!"
        })
      });
    } else if (response.error) {
      // if there are errors in the response show them in snackbar
      dispatch({
        type: 'HANDLE_ERROR',
        error: response.error.message
      });
    } else {
      // if there are no errors, make the purchase with or whithout the coupon
      if (addedPromoCode) {
        dispatch({
          type: 'STRIPE_PURCHASE',
          token: response.id,
          coupon: promoCode,
          history: history
        });
      } else {
        dispatch({
          type: 'STRIPE_PURCHASE',
          token: response.id,
          history: history
        });
      }
    }
  };
  var handleStripePaymentWithCardOnly = function handleStripePaymentWithCardOnly(response) {
    if (!response) {
      // if there is no response show error snackbar
      dispatch({
        type: 'HANDLE_ERROR',
        error: /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
          id: "Something went wrong!",
          defaultMessage: "Something went wrong!"
        })
      });
    } else if (response.error) {
      // if there are errors in the response show them in snackbar
      dispatch({
        type: 'HANDLE_ERROR',
        error: response.error.message
      });
    } else {
      // if there are no errors, make the purchase with or whithout the coupon
      if (addedPromoCode) {
        dispatch({
          type: 'INTERNAL_PURCHASE',
          params: {
            payment_method_token: response.id,
            coupon: promoCode
          },
          history: history
        });
      } else {
        dispatch({
          type: 'INTERNAL_PURCHASE',
          params: {
            payment_method_token: response.id
          },
          history: history
        });
      }
    }
  };
  var createFormData = function createFormData(address) {
    var _address$item, _address$item$options, _address$address, _address$address2;
    var formData = new FormData();
    var options = [];
    var colissimo_data = {};

    // check if selected shipping is colissimo
    if (Colissimo && address.choice_uuid === COLISSIMO_CHOICE_OF_OPTION_UUID) {
      colissimo_data = {
        pick_up_location_id: address.pick_up_location_id,
        colissimo_address: address.colissimo_address
      };
    }
    address === null || address === void 0 ? void 0 : (_address$item = address.item) === null || _address$item === void 0 ? void 0 : (_address$item$options = _address$item.options_linked_to_cart_item) === null || _address$item$options === void 0 ? void 0 : _address$item$options.forEach(function (option) {
      if (option.option_uuid === _config.SHIPPING_OPTION_UUID) {
        options.push(option);
      }
    });
    options.length > 0 && options.forEach(function (option, index) {
      formData.append("options_linked_to_cart_item-".concat(index, "-inline_delete"), 'true');
      formData.append("options_linked_to_cart_item-".concat(index, "-id"), option.id);
    });
    formData.append("options_linked_to_cart_item-".concat(options.length + 1, "-option_class"), 'OptionOfProduct');
    formData.append("options_linked_to_cart_item-".concat(options.length + 1, "-option_uuid"), _config.SHIPPING_OPTION_UUID);
    formData.append("options_linked_to_cart_item-".concat(options.length + 1, "-type"), 'list');
    (address === null || address === void 0 ? void 0 : address.choice_uuid) === SHIPPING_FREE_OPTION ? formData.append("options_linked_to_cart_item-".concat(options.length + 1, "-extra_data"), JSON.stringify(_objectSpread(_objectSpread({}, colissimo_data), {}, {
      address: (_address$address = address.address) !== null && _address$address !== void 0 && _address$address.address_01 ? address.address : '',
      choices: [{
        choice_uuid: address.choice_uuid
      }],
      phone: user !== null && user !== void 0 && user.phone ? user === null || user === void 0 ? void 0 : user.phone : ""
    }))) : formData.append("options_linked_to_cart_item-".concat(options.length + 1, "-extra_data"), JSON.stringify(_objectSpread(_objectSpread({}, colissimo_data), {}, {
      address: (_address$address2 = address.address) !== null && _address$address2 !== void 0 && _address$address2.address_01 ? address.address : '',
      choices: [{
        choice_uuid: address.choice_uuid
      }]
    })));
    return formData;
  };
  var checkAllitemsHaveShipping = function checkAllitemsHaveShipping(address) {
    if (address.choice_uuid === _config.SHIPPING_CHOICE_ASK_ADDRESS_UUID) {
      // If shpping needs address check if it's selected
      if (address.address) {
        return Boolean(address.address);
        // or that it already has been selected before in the cartitem
      } else {
        var _address$item2, _address$item2$option, _itemShipping$extra_d;
        var itemShipping = (_address$item2 = address.item) === null || _address$item2 === void 0 ? void 0 : (_address$item2$option = _address$item2.options_linked_to_cart_item) === null || _address$item2$option === void 0 ? void 0 : _address$item2$option.find(function (item) {
          return item.option_uuid === _config.SHIPPING_OPTION_UUID;
        });
        return Boolean(itemShipping === null || itemShipping === void 0 ? void 0 : (_itemShipping$extra_d = itemShipping.extra_data) === null || _itemShipping$extra_d === void 0 ? void 0 : _itemShipping$extra_d.address);
      }
    } else {
      return Boolean(address.choice_uuid);
    }
  };
  var calculateAmountToBePayed = function calculateAmountToBePayed() {
    var total_amount = _config.COUPON_ENABLED ? cart === null || cart === void 0 ? void 0 : cart.total_price_with_coupon : cart.total_amount;
    if (!_config.KITTY_ENABLED) return total_amount;
    return (total_amount - kittyAmount / _config.KITTY_EXCHANGE_RATE).toFixed(2);
  };
  var onPayment = function onPayment() {
    if (_config.KITTY_ENABLED) dispatch({
      type: 'UPDATE_KITTY_AMOUNT',
      payload: kittyAmount / _config.KITTY_EXCHANGE_RATE
    });
    openConfirmDialog()();
  };
  (0, _react.useEffect)(function () {
    // Check that all the addresses have been selected
    var shippingAddressesAreSelected = shippingAddresses.every(function (adr) {
      return checkAllitemsHaveShipping(adr);
    });
    var shippingAddressesToUpdate = shippingAddresses.filter(function (adr) {
      return adr.changed;
    });
    // Update the cart items that had their address changed
    if ((shippingAddressesToUpdate === null || shippingAddressesToUpdate === void 0 ? void 0 : shippingAddressesToUpdate.length) > 0) {
      dispatch({
        type: 'SET_CARTITEM_SHIPPING',
        items: shippingAddressesToUpdate.map(function (adr) {
          return {
            id: adr.item.id,
            model: createFormData(adr)
          };
        }),
        onSuccess: function onSuccess() {
          return setIsShippingChecked(true);
        }
      });
      setShippongSelectionInProgress(true);

      // this is for removing the duplicated requests by making the updated addresse status to not changed
      // because the changes already committed (PTACHED)
      setShippingAddresses(shippingAddresses.map(function (adr) {
        return _objectSpread(_objectSpread({}, adr), {}, {
          changed: false
        });
      }));
    }
    if (shippingAddressesAreSelected) {
      setIsShippingChecked(true);
    } else {
      setIsShippingChecked(false);
    }
  }, [shippingAddresses]);
  var disabelCheckout = inProgress || fetchCartInProgress || !isShippingChecked;
  var shippingAmount = (0, _react.useMemo)(function () {
    var _cart$cart_items2;
    return cart === null || cart === void 0 ? void 0 : (_cart$cart_items2 = cart.cart_items) === null || _cart$cart_items2 === void 0 ? void 0 : _cart$cart_items2.filter(function (item) {
      return !item.is_primary_product && item.salable_item_uuid === _config.SHIPPING_OPTION_UUID;
    }).map(function (item) {
      return item.total_price;
    }).reduce(function (a, b) {
      return a + b;
    }, 0);
  }, [cart]);
  var ItemsAmount = (0, _react.useMemo)(function () {
    var _cart$cart_items3;
    return cart === null || cart === void 0 ? void 0 : (_cart$cart_items3 = cart.cart_items) === null || _cart$cart_items3 === void 0 ? void 0 : _cart$cart_items3.filter(function (item) {
      return item.is_primary_product === true;
    }).map(function (item) {
      return item.total_price;
    }).reduce(function (a, b) {
      return a + b;
    }, 0);
  }, [cart]);
  var cart_items = (0, _react.useMemo)(function () {
    var _cart$cart_items4;
    return cart === null || cart === void 0 ? void 0 : (_cart$cart_items4 = cart.cart_items) === null || _cart$cart_items4 === void 0 ? void 0 : _cart$cart_items4.filter(function (item) {
      return item.is_primary_product === true;
    });
  });

  // TODO: This part must be re-implemented when we make caution generic
  //  I didn't override all the shopping cart module because it is complicated.
  //  This part of code is for swaptheroad.
  var hasCaution = (0, _react.useMemo)(function () {
    var _cart$cart_items5;
    return (cart === null || cart === void 0 ? void 0 : (_cart$cart_items5 = cart.cart_items) === null || _cart$cart_items5 === void 0 ? void 0 : _cart$cart_items5.filter(function (item) {
      var _item$salable_item2;
      return (_item$salable_item2 = item.salable_item) === null || _item$salable_item2 === void 0 ? void 0 : _item$salable_item2.caution;
    }).length) > 0;
  }, [cart]);

  // I use the first salable item because we must reserve one product only.
  // this part is for swaptheroad.
  var cautionAmount = (0, _react.useMemo)(function () {
    var _cart$cart_items6, _cart$cart_items6$fil, _cart$cart_items6$fil2, _cart$cart_items6$fil3;
    return cart === null || cart === void 0 ? void 0 : (_cart$cart_items6 = cart.cart_items) === null || _cart$cart_items6 === void 0 ? void 0 : (_cart$cart_items6$fil = _cart$cart_items6.filter(function (item) {
      return item.is_primary_product === true;
    })[0]) === null || _cart$cart_items6$fil === void 0 ? void 0 : (_cart$cart_items6$fil2 = _cart$cart_items6$fil.salable_item) === null || _cart$cart_items6$fil2 === void 0 ? void 0 : (_cart$cart_items6$fil3 = _cart$cart_items6$fil2.caution) === null || _cart$cart_items6$fil3 === void 0 ? void 0 : _cart$cart_items6$fil3.amount;
  }, [cart]);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, cart_items && /*#__PURE__*/_react.default.createElement(_core.Paper, {
    className: (0, _classnames.default)("", classes.cardShadow)
  }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
    container: true
  }, /*#__PURE__*/_react.default.createElement(_core.Box, {
    clone: true,
    order: {
      xs: 1,
      md: 1,
      lg: 1
    }
  }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    md: 12,
    lg: 8,
    className: "p-4 pb-8"
  }, /*#__PURE__*/_react.default.createElement(_core.Card, {
    className: classes.cardShadow
  }, /*#__PURE__*/_react.default.createElement(_core.CardContent, {
    style: {
      padding: "0px"
    }
  }, /*#__PURE__*/_react.default.createElement(_core.GridList, {
    cellHeight: "auto",
    style: {
      display: "flex",
      flexWrap: "wrap",
      justifyContent: "space-around",
      overflow: "hidden",
      backgroundColor: "primary"
    }
  }, /*#__PURE__*/_react.default.createElement(_core.GridListTile, {
    key: "Subheader",
    cols: 2,
    style: {
      height: "auto"
    }
  }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
    className: classes.title,
    item: true,
    xs: 12
  }, /*#__PURE__*/_react.default.createElement(_core.Typography, {
    className: classes.titleText,
    variant: "overline"
  }, /*#__PURE__*/_react.default.createElement(_core.ListSubheader, {
    component: "div"
  }, /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
    id: "Cart items :",
    defaultMessage: "Cart items :"
  }))))), /*#__PURE__*/_react.default.createElement(_core.List, {
    sm: 12,
    style: {
      backgroundColor: "#ffff",
      width: "100%",
      padding: "10px"
    }
  }, cart_items.map(function (item, index) {
    var _item$salable_item3, _item$salable_item3$i, _item$salable_item4, _item$salable_item4$i;
    // Item
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, {
      key: item.id
    }, /*#__PURE__*/_react.default.createElement(_core.Divider, {
      style: {
        height: "3px"
      }
    }), /*#__PURE__*/_react.default.createElement(_core.ListItem, {
      key: item.id,
      divider: index + 1 < cart_items.length ? true : false
    }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
      container: true,
      alignItems: "center",
      className: index + 1 < cart_items.length ? "mb-2" : ""
    }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
      item: true,
      xs: 12,
      lg: 2
    }, ((_item$salable_item3 = item.salable_item) === null || _item$salable_item3 === void 0 ? void 0 : (_item$salable_item3$i = _item$salable_item3.images) === null || _item$salable_item3$i === void 0 ? void 0 : _item$salable_item3$i.length) > 0 ? /*#__PURE__*/_react.default.createElement(_core.CardMedia, {
      title: "salable-item",
      style: {
        height: 110,
        width: 80
      },
      image: (0, _helpers.joinPaths)(_config.BASE_URL, item === null || item === void 0 ? void 0 : (_item$salable_item4 = item.salable_item) === null || _item$salable_item4 === void 0 ? void 0 : (_item$salable_item4$i = _item$salable_item4.images[0]) === null || _item$salable_item4$i === void 0 ? void 0 : _item$salable_item4$i.url)
    }) : /*#__PURE__*/_react.default.createElement(_core.Avatar, {
      style: {
        height: 60,
        width: 60
      }
    })), /*#__PURE__*/_react.default.createElement(_core.Hidden, {
      lgUp: true
    }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
      item: true,
      xs: 12,
      className: "py-8"
    }, /*#__PURE__*/_react.default.createElement(_core.Divider, null))), /*#__PURE__*/_react.default.createElement(_core.Grid, {
      container: true,
      item: true,
      xs: 12,
      lg: 10
    }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
      container: true,
      item: true,
      xs: 12,
      alignItems: "center"
    }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
      item: true,
      xs: 12,
      md: 8
    }, /*#__PURE__*/_react.default.createElement(_core.Typography, {
      variant: "h6"
    }, item.salable_item.salable_item_mxn_name)), /*#__PURE__*/_react.default.createElement(_core.Grid, {
      container: true,
      item: true,
      xs: 12,
      md: 4,
      justify: "flex-end"
    }, /*#__PURE__*/_react.default.createElement(_core.Typography, {
      variant: "overline",
      className: "text-lg"
    }, item.total_price, " ", /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
      id: "\u20AC",
      defaultMessage: "\u20AC"
    })))), /*#__PURE__*/_react.default.createElement(_core.Grid, {
      container: true,
      item: true,
      xs: 12,
      className: "pb-4",
      justify: !item.can_update_quantity && "flex-end"
    }, item.can_update_quantity && /*#__PURE__*/_react.default.createElement(_Quantity.default, _extends({}, item, {
      initialQuantity: item.quantity
    })), /*#__PURE__*/_react.default.createElement(_core.Grid, {
      item: true,
      container: true,
      xs: 12,
      md: 4,
      justify: "flex-end"
    }, /*#__PURE__*/_react.default.createElement(_core.Button, {
      variant: "outlined",
      size: "small",
      color: "secondary",
      onClick: function onClick() {
        return props.dispatch({
          type: "DELETE_ITEM_FROM_CART",
          id: item.id
        });
      }
    }, /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
      id: "Retirer",
      defaultMessage: "Retirer"
    })))), /*#__PURE__*/_react.default.createElement(_core.Grid, {
      item: true,
      xs: 12
    }, ShippingFields && /*#__PURE__*/_react.default.createElement(ShippingFields, {
      disabled: shippongSelectionInProgress,
      shippingAddresses: shippingAddresses,
      setShippingAddresses: setShippingAddresses,
      item: item,
      enableCheckout: function enableCheckout() {
        return setIsShippingChecked(true);
      }
    })), /*#__PURE__*/_react.default.createElement(_core.Grid, {
      item: true,
      xs: 12,
      md: 5
    }, !!ReservationPresentation && !_lodash.default.isEmpty(item.options_linked_to_cart_item) && item.options_linked_to_cart_item.map(function (option, index) {
      return option.option_uuid === RESERVATION_OPTION_UUID && /*#__PURE__*/_react.default.createElement(ReservationPresentation, {
        key: index,
        startDate: option.extra_data.start_date,
        periodicityId: option.extra_data.periodicity,
        numPeriodicity: option.extra_data.num_periodicity
      });
    }))))));
    // END Item
  }))), _config.PAYMENT_METHOD === _config.PAYMENT_METHODS.STRIPE && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_core.Grid, {
    className: classes.title,
    item: true,
    xs: 12
  }, /*#__PURE__*/_react.default.createElement(_core.Typography, {
    className: classes.titleText,
    variant: "overline"
  }, /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
    id: "Payment method details :",
    defaultMessage: "Payment method details :"
  }))), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_reactStripeElements.Elements, null, /*#__PURE__*/_react.default.createElement(_Stripe.default, {
    handlePayment: handlePayment,
    formRef: stripeFormRef
  })))), _config.PAYMENT_METHOD === _config.PAYMENT_METHODS.INTERNAL_PAYMENT_WITH_STRIPE_CARD_ONLY && hasCaution && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_core.Grid, {
    className: classes.title,
    item: true,
    xs: 12
  }, /*#__PURE__*/_react.default.createElement(_core.Typography, {
    className: classes.titleText,
    variant: "subtitle1"
  }, /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
    id: "Merci de renseigner les informations de votre carte bancaire afin de bloquer la somme de la caution/franchise de ",
    defaultMessage: "Merci de renseigner les informations de votre carte bancaire afin de bloquer la somme de la caution/franchise de "
  }), cautionAmount, /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
    id: "\u20AC ?",
    defaultMessage: "\u20AC ?"
  }))), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_reactStripeElements.Elements, null, /*#__PURE__*/_react.default.createElement(_StripeCard.default, {
    handlePayment: handleStripePaymentWithCardOnly,
    formRef: stripeCardFormRef
  })))))))), /*#__PURE__*/_react.default.createElement(_core.Box, {
    clone: true,
    order: {
      xs: 2,
      md: 2,
      lg: 2
    }
  }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    md: 12,
    lg: 4,
    className: "p-4"
  }, /*#__PURE__*/_react.default.createElement(_core.Card, {
    className: classes.cardShadow
  }, /*#__PURE__*/_react.default.createElement(_core.CardContent, {
    style: {
      padding: "0px"
    }
  }, /*#__PURE__*/_react.default.createElement(_core.GridList, {
    cellHeight: "auto",
    style: {
      display: "flex",
      flexWrap: "wrap",
      justifyContent: "space-around",
      overflow: "hidden",
      backgroundColor: "primary"
    }
  }, /*#__PURE__*/_react.default.createElement(_core.GridListTile, {
    key: "Subheader",
    cols: 2,
    style: {
      height: "auto"
    }
  }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
    className: classes.title,
    item: true,
    xs: 12
  }, /*#__PURE__*/_react.default.createElement(_core.Typography, {
    className: classes.titleText,
    variant: "overline"
  }, /*#__PURE__*/_react.default.createElement(_core.ListSubheader, {
    component: "div"
  }, /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
    id: "Checkout :",
    defaultMessage: "Checkout :"
  }), " ")))), /*#__PURE__*/_react.default.createElement(_core.Grid, {
    container: true,
    style: {
      backgroundColor: "#ffff",
      width: "100%",
      padding: "20px"
    }
  }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/_react.default.createElement(_core.Typography, {
    variant: "overline"
  }, /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
    id: "Articles :",
    defaultMessage: "Articles :"
  }), " ", /*#__PURE__*/_react.default.createElement("strong", null, cart_items.length))), /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    xs: 12,
    className: "py-8"
  }, /*#__PURE__*/_react.default.createElement(_core.Divider, null)), /*#__PURE__*/_react.default.createElement(_core.Grid, {
    container: true,
    item: true,
    xs: 12
  }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    xs: 8
  }, /*#__PURE__*/_react.default.createElement(_core.Typography, {
    variant: "overline"
  }, /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
    id: "Subtotal :",
    defaultMessage: "Subtotal :"
  }))), /*#__PURE__*/_react.default.createElement(_core.Grid, {
    container: true,
    item: true,
    xs: 4,
    justify: "flex-end"
  }, /*#__PURE__*/_react.default.createElement("strong", null, ItemsAmount, " ", /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
    id: "\u20AC",
    defaultMessage: "\u20AC"
  })))), ShippingFields && /*#__PURE__*/_react.default.createElement(_core.Grid, {
    container: true,
    item: true,
    xs: 12
  }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    xs: 8
  }, /*#__PURE__*/_react.default.createElement(_core.Typography, {
    variant: "overline"
  }, /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
    id: "Livraison :",
    defaultMessage: "Livraison :"
  }))), /*#__PURE__*/_react.default.createElement(_core.Grid, {
    container: true,
    item: true,
    xs: 4,
    justify: "flex-end"
  }, /*#__PURE__*/_react.default.createElement("strong", null, shippingAmount, " ", /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
    id: "\u20AC",
    defaultMessage: "\u20AC"
  })))), /*#__PURE__*/_react.default.createElement(_core.Grid, {
    container: true,
    item: true,
    xs: 12
  }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    xs: 8
  }, /*#__PURE__*/_react.default.createElement(_core.Typography, {
    variant: "overline"
  }, /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
    id: "Co\xFBt total :",
    defaultMessage: "Co\xFBt total :"
  }))), /*#__PURE__*/_react.default.createElement(_core.Grid, {
    container: true,
    item: true,
    xs: 4,
    justify: "flex-end"
  }, /*#__PURE__*/_react.default.createElement("strong", null, cart.total_amount, " ", /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
    id: "\u20AC",
    defaultMessage: "\u20AC"
  })))), /*#__PURE__*/_react.default.createElement(_core.Grid, {
    container: true,
    item: true,
    xs: 12
  }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    xs: 8
  }, /*#__PURE__*/_react.default.createElement(_core.Typography, {
    variant: "overline"
  }, /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
    id: "Montant \xE0 payer :",
    defaultMessage: "Montant \xE0 payer :"
  }))), /*#__PURE__*/_react.default.createElement(_core.Grid, {
    container: true,
    item: true,
    xs: 4,
    justify: "flex-end"
  }, /*#__PURE__*/_react.default.createElement("strong", null, calculateAmountToBePayed(), " ", /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
    id: "\u20AC",
    defaultMessage: "\u20AC"
  })))), _config.COUPON_ENABLED && !_config.HIDE_COUPON && /*#__PURE__*/_react.default.createElement(_PromoCode.default, null), _config.KITTY_ENABLED && /*#__PURE__*/_react.default.createElement(_Kitty.default, {
    handleKitty: setKittyAmount
  }), /*#__PURE__*/_react.default.createElement(_core.Grid, {
    container: true,
    item: true,
    className: "mb-6 pt-6",
    justify: "center"
  }, /*#__PURE__*/_react.default.createElement(_core.FormControlLabel, {
    control: /*#__PURE__*/_react.default.createElement(_core.Checkbox, {
      name: "accept CGU",
      required: true,
      checked: isConditionsChecked,
      onChange: function onChange(event) {
        return handleConditionsChecked(event.target.checked);
      }
    }),
    label: /*#__PURE__*/_react.default.createElement("a", (_React$createElement = {
      target: "_blank",
      href: "".concat(_config.BASE_URL).concat(props.intl.formatMessage({
        id: "cgv_url",
        defaultMessage: "cgv_url"
      }))
    }, _defineProperty(_React$createElement, "target", "_blank"), _defineProperty(_React$createElement, "rel", "noopener noreferrer"), _React$createElement), /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
      id: "J'accepte les CGV"
    }))
  }), _config.PAYMENT_METHOD === _config.PAYMENT_METHODS.STRIPE && /*#__PURE__*/_react.default.createElement(_core.Button, {
    className: "w-40",
    type: "submit",
    variant: "contained",
    color: "primary",
    onClick: function onClick() {
      var _stripeFormRef$curren;
      return (_stripeFormRef$curren = stripeFormRef.current) === null || _stripeFormRef$curren === void 0 ? void 0 : _stripeFormRef$curren.handleSubmit();
    },
    disabled: showPromoCodeField && !addedPromoCode || !isConditionsChecked || inProgress
  }, /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
    id: "Pay",
    defaultMessage: "Pay"
  })), _config.PAYMENT_METHOD === _config.PAYMENT_METHODS.INTERNAL_PAYMENT_WITH_STRIPE_CARD_ONLY && (hasCaution ? /*#__PURE__*/_react.default.createElement(_core.Button, {
    className: "w-40",
    type: "submit",
    variant: "contained",
    color: "primary",
    onClick: function onClick() {
      var _stripeCardFormRef$cu;
      (_stripeCardFormRef$cu = stripeCardFormRef.current) === null || _stripeCardFormRef$cu === void 0 ? void 0 : _stripeCardFormRef$cu.handleSubmit();
    },
    disabled: showPromoCodeField && !addedPromoCode || !isConditionsChecked || inProgress
  }, /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
    id: "Pay",
    defaultMessage: "Pay"
  })) : /*#__PURE__*/_react.default.createElement(_core.Button, {
    variant: "contained",
    color: "primary",
    onClick: onPayment,
    disabled: disabelCheckout || !isConditionsChecked
  }, /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
    id: "Pay",
    defaultMessage: "Pay"
  }))), _config.PAYMENT_METHOD === _config.PAYMENT_METHODS.MANGOPAY && /*#__PURE__*/_react.default.createElement(_core.Button, {
    variant: "contained",
    color: "primary",
    onClick: onPayment,
    disabled: disabelCheckout || !isConditionsChecked
  }, /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
    id: "Paiement",
    defaultMessage: "Paiement"
  })), _config.PAYMENT_METHOD === _config.PAYMENT_METHODS.INTERNAL_PAYMENT && /*#__PURE__*/_react.default.createElement(_core.Button, {
    variant: "contained",
    color: "primary",
    onClick: onPayment,
    disabled: disabelCheckout || !isConditionsChecked
  }, /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
    id: "Pay",
    defaultMessage: "Pay"
  }))))))))))));
}
var _default = (0, _reactRouterDom.withRouter)((0, _reactRedux.connect)(function (state) {
  return {
    user: state.auth.user,
    inProgress: state.purchaseReducer.inProgress,
    cart: state.shoppingCartReducer.cart
  };
})((0, _reactIntl.injectIntl)(ShoppingCartList)));
exports.default = _default;